import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, message, Typography, Select } from 'antd';
import {
	downloadLocationsCSVForBuyer,
	locationsRestCrudThunksForBuyer,
} from '../../thunks/locations_thunks';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { EmptyState } from '../empty_state/EmptyState';
import {
	nullSafeGet,
	changeFilterValueToArrayOfIds,
	getTupleNameFieldName,
	nullSafeGetOrElse,
	getTupleValueFieldName,
} from '../../utils/DataAccessUtils';
import { EmptorTag } from '../emptor_tag/EmptorTag';
import { LOCATIONS_CRUD_ACTION_CREATORS } from '../../actions/locations_actions';
import { BUYER_ONLY_NO_STORE_ASSOCIATE } from '../roles/roles';
import { buyerRoleUpdateUser } from '../../thunks/buyer_contacts_thunks';
import BuyerRoleUpdateForm from '../buyer_role_update_form/BuyerRoleUpdateForm';
import {
	fetchRegionsWithChildrenForBuyer,
	regionsRestCrudThunksForBuyer,
} from '../../thunks/regions_thunks';
import { FILTER_CONFIG_NAMES, FILTER_FIELD_TYPE } from '../../utils/DataConstants';
import ProblemTypeTreeSelect from '../problem_type_tree_select';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import OWAsyncTupleSelect from '../ow_async_select/OWAsyncTupleSelect';
import { locationTypesAdditionalFieldsRestCrudThunksForBuyer } from '../../thunks/location_types_additional_fields_thunks';
import { brandsRestCrudThunksForBuyer } from '../../thunks/brands_thunks';
import { locationTypesRestCrudThunksForBuyer } from '../../thunks/location_types_thunks';
import { getIsActiveFilterField, INITIAL_IS_ACTIVE_FILTERS } from '../../utils/FilterUtils';
import ReduxDataTable from '../redux_data_table/ReduxDataTable';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import OWButtonWithSupplierManagedLock from '../common/OWButtonWithSupplierManagedLock';
import { DownloadOutlined } from '@ant-design/icons';
import BrandLogoDisplay from '../brands_overview_index_page/BrandLogoDisplay';

require('./LocationsIndexPage.less');
const { Text } = Typography;

const TC_NAME = 'locationsIndex';

const LOCATIONS_OVERVIEW_TARGET_COLLECTION = 'locationsIndex';

class LocationsIndexPage extends React.Component<any, any> {
	formRefs: any;
	initialFilters: any;
	initialPagination: any = { current: 1, pageSize: 10 };

	constructor(props) {
		super(props);
		this.handleBuyerRoleUpdateSubmit = this.handleBuyerRoleUpdateSubmit.bind(this);
		this.handleBuyerRoleUpdateCancel = this.handleBuyerRoleUpdateCancel.bind(this);
		this.formRefs = {
			roleUpdateForm: null,
		};
		this.state = {
			displayMode: 'list',
			exporting: false,
		};
	}

	switchDisplayMode = (mode) => this.setState({ displayMode: mode });
	isDisplayModeActive = (mode) => this.state.displayMode === mode;

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	showRoleUpdateModal = (record) => (e) => {
		this.setState({
			roleUpdateVisible: true,
			userContact: {
				contact: {
					...record,
				},
				role: record['roles'],
				locationIds: record['locationIds'] || [],
			},
		});
	};

	handleBuyerRoleUpdateSubmit() {
		const { roleUpdateUser, history } = this.props;
		const form = this.formRefs['roleUpdateForm'].props.form;
		form.validateFields((err, values) => {
			if (err) {
				return;
			}

			const updateRole = {
				userId: values.email,
				roles: [values.roles],
				locationIds: values.locationIds,
			};

			roleUpdateUser(updateRole).then(() => {
				this.setState({ roleUpdateVisible: false });
				form.resetFields();
				message.success(`Location Access Granted`);
				history.push(`/buyer/locations/overview/all`);
			});
		});
	}

	handleBuyerRoleUpdateCancel(e) {
		this.setState({
			roleUpdateVisible: false,
		});
	}

	downloadCSV = () => {
		const { locations, exportLocations } = this.props;
		const filters = nullSafeGetOrElse(`${TC_NAME}.filters`, locations, {});
		this.setState({ exporting: true });
		exportLocations(filters)
			.catch((err) => message.error(err))
			.finally(() => this.setState({ exporting: false }));
	};

	render() {
		const {
			history,
			locations,
			updateLocationsFilters,
			currentUser,
			regions,
			fetchRegionsWithChildren,
			fetchMultipleRegions,
			location,
			locationTypesAdditionalFields,
			fetchLocationTypesAdditionalFields,
			fetchMultipleLocationTypesAdditionalFields,
			brands,
			fetchBrands,
			fetchMultipleBrands,
			locationTypes,
			fetchLocationTypes,
			fetchMultipleLocationTypes,
		} = this.props;
		const popupRenderFunc = (record) => `
            <div>
                <a href="/buyer/locations/detail/${record.id}">
                    <div class="locationsIndexPage__row" style="align-items: flex-start;">
                        <div style="margin-right: 24px;">
                            <div
                                class="locationsIndexPage__rowTitle"
                            >
                                ${record.name}
                            </div>
                            <div
                                class="locationsIndexPage__rowSubtitle"
                            >
                                    ${nullSafeGet(
																			'buyerFacility.primaryAddress.streetAddress1',
																			record
																		)}
                            </div>
                        </div>
                        <div class="emptorTag locationsIndexPage__pill">
                            ${
															record.totalNotClosedWOCount > 0
																? record.totalNotClosedWOCount + ' Open WOs'
																: 'No Open WOs'
														}
                        </div>
                    </div>
                    <div
                        class="locationsIndexPage__rowSubtitle"
                    >
                        <div class="locationsIndexPage__rowInlineGroup">
                            ${nullSafeGet(
															'buyerFacility.primaryAddress.city',
															record
														)}, ${nullSafeGet(
			'buyerFacility.primaryAddress.region',
			record
		)} ${nullSafeGet('buyerFacility.primaryAddress.postcode', record)}
                        </div>
                    </div>
                </a>
            </div>
        `;

		const columns = [
			{
				title: 'Name',
				dataIndex: 'name',
				defaultSortOrder: 'ascend',
				render: (text, record) => (
					<div className="locationsIndexPage__row">
						<div>
							<div className="flex">
								<BrandLogoDisplay brand={nullSafeGet('brand', record)} />
								<div>
									<div className="locationsIndexPage__rowTitle">
										<Ellipsis tooltip={true} length={64}>
											{record.name}
										</Ellipsis>
									</div>
									<div className="locationsIndexPage__rowSubtitle">
										<div className="locationsIndexPage__rowInlineGroup">
											{nullSafeGet('buyerFacility.primaryAddress.city', record)}
										</div>
										<div className="locationsIndexPage__rowInlineGroup2">
											{nullSafeGet('locationType.name', record)} {nullSafeGet('storeId', record)}
										</div>
										{record.isActive ? null : (
											<div className="locationsIndexPage__rowInlineGroup">
												<Text className={'mr-1'} type={'danger'}>
													Inactive
												</Text>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
						<div className="flex items-end">
							<EmptorTag className="locationsIndexPage__pill">
								{record.totalNotClosedWOCount > 0
									? record.totalNotClosedWOCount + ' Open WOs'
									: 'No Open WOs'}
							</EmptorTag>
						</div>
					</div>
				),
			},
		];

		const onRow = (record) => ({
			onClick: () => {
				const path = `/buyer/locations/detail/${nullSafeGet(
					'id',
					record
				)}/details?targetCollectionName=${LOCATIONS_OVERVIEW_TARGET_COLLECTION}`;
				history.push(
					getLinkWIthBackLinkParams(location, 'Back to Assets', path, {
						preserve: true,
					})
				);
			},
		});

		const filterConfig = [
			{
				label: 'Region',
				mode: 'multiple',
				stateSlice: regions,
				fieldName: FILTER_CONFIG_NAMES.REGION,
				filtersValueAccessor: (filtersStateSlice) => {
					const ids = nullSafeGet(
						`${LOCATIONS_OVERVIEW_TARGET_COLLECTION}.filters.${FILTER_CONFIG_NAMES.REGION}`,
						filtersStateSlice
					);
					return changeFilterValueToArrayOfIds(ids);
				},
				keyAccessor: (region) => region.id,
				valueAccessor: (region) => region.id,
				handleChange: (ids) => {
					updateLocationsFilters(
						{
							[FILTER_CONFIG_NAMES.REGION]: ids.join(',') || undefined,
						},
						LOCATIONS_OVERVIEW_TARGET_COLLECTION
					);
				},
				targetCollectionName: 'locationsAdvancedFilters',
				fetch: fetchRegionsWithChildren,
				fetchMultiple: fetchMultipleRegions,
				renderItem: (region) => region.name,
				sortBy: { sort_by: 'name', order: 'ascend' },
				component: ProblemTypeTreeSelect,
			},
			{
				label: 'Location Types',
				mode: 'multiple',
				fieldName: FILTER_CONFIG_NAMES.LOCAATION_TYPE,
				stateSlice: locationTypes,
				filtersValueAccessor: (filtersStateSlice) => {
					const ids = nullSafeGet(
						`${LOCATIONS_OVERVIEW_TARGET_COLLECTION}.filters.${FILTER_CONFIG_NAMES.LOCAATION_TYPE}`,
						filtersStateSlice
					);
					return changeFilterValueToArrayOfIds(ids);
				},
				keyAccessor: (lt) => lt.id,
				valueAccessor: (lt) => lt.id,
				handleChange: (ids) => {
					updateLocationsFilters(
						{
							[FILTER_CONFIG_NAMES.LOCAATION_TYPE]: ids.join(',') || undefined,
						},
						LOCATIONS_OVERVIEW_TARGET_COLLECTION
					);
				},
				targetCollectionName: 'locationsAdvancedFilters',
				fetch: fetchLocationTypes,
				fetchMultiple: fetchMultipleLocationTypes,
				renderItem: (lt) => lt.name,
				sortBy: { sort_by: 'name', order: 'ascend' },
			},
			{
				label: 'Brand',
				mode: 'multiple',
				stateSlice: brands,
				fieldName: FILTER_CONFIG_NAMES.BRAND,
				filtersValueAccessor: (filtersStateSlice) => {
					const ids = nullSafeGet(
						`${LOCATIONS_OVERVIEW_TARGET_COLLECTION}.filters.${FILTER_CONFIG_NAMES.BRAND}`,
						filtersStateSlice
					);
					return changeFilterValueToArrayOfIds(ids);
				},
				keyAccessor: (brand) => brand.id,
				valueAccessor: (brand) => brand.id,
				handleChange: (ids) => {
					updateLocationsFilters(
						{
							[FILTER_CONFIG_NAMES.BRAND]: ids.join(',') || undefined,
						},
						LOCATIONS_OVERVIEW_TARGET_COLLECTION
					);
				},
				targetCollectionName: 'locationsAdvancedFilters',
				fetch: fetchBrands,
				fetchMultiple: fetchMultipleBrands,
				renderItem: (brand) => brand.brandName,
				sortBy: { sort_by: 'name', order: 'ascend' },
			},
			{
				label: 'Additional Fields',
				fieldName: FILTER_CONFIG_NAMES.ADDITIONAL_FIELD,
				type: FILTER_FIELD_TYPE.TUPLE,
				stateSlice: locationTypesAdditionalFields,
				filtersValueAccessor: (filtersStateSlice) => {
					const name = nullSafeGet(
						`${LOCATIONS_OVERVIEW_TARGET_COLLECTION}.filters.${getTupleNameFieldName(
							FILTER_CONFIG_NAMES.ADDITIONAL_FIELD
						)}`,
						filtersStateSlice
					);
					const value = nullSafeGet(
						`${LOCATIONS_OVERVIEW_TARGET_COLLECTION}.filters.${getTupleValueFieldName(
							FILTER_CONFIG_NAMES.INSTALL_AT
						)}`,
						filtersStateSlice
					);
					return [name, value];
				},
				handleChange: (values) => {
					updateLocationsFilters(
						{
							[getTupleNameFieldName(FILTER_CONFIG_NAMES.ADDITIONAL_FIELD)]: nullSafeGetOrElse(
								'0',
								values,
								undefined
							),
							[getTupleValueFieldName(FILTER_CONFIG_NAMES.ADDITIONAL_FIELD)]: nullSafeGetOrElse(
								'1',
								values,
								undefined
							),
						},
						LOCATIONS_OVERVIEW_TARGET_COLLECTION
					);
				},
				targetCollectionName: 'locationsAdvancedFilters',
				fetch: fetchLocationTypesAdditionalFields,
				fetchMultiple: fetchMultipleLocationTypesAdditionalFields,
				renderRecord: (entity) => (
					<Select.Option key={entity.id} value={entity.id}>
						<div className="flex flex-row items-center">
							<div>{entity.name}</div>
						</div>
					</Select.Option>
				),
				valueAccessor: (item) => item.name,
				component: OWAsyncTupleSelect,
			},
			...[
				getIsActiveFilterField(updateLocationsFilters, LOCATIONS_OVERVIEW_TARGET_COLLECTION, true),
			],
		];

		return (
			<div className="locationsIndexPage">
				<BuyerRoleUpdateForm
					wrappedComponentRef={this.saveFormRef('roleUpdateForm')}
					visible={this.state.roleUpdateVisible}
					formData={this.state.userContact}
					onCancel={this.handleBuyerRoleUpdateCancel}
					onSubmit={this.handleBuyerRoleUpdateSubmit}
					isLocationChange={true}
				/>

				<ReduxDataTable
					filterConfig={filterConfig}
					rightActions={
						<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
							<Button
								size="large"
								icon={<DownloadOutlined />}
								className="inline-block-visible-md"
								loading={this.state.exporting}
								onClick={this.downloadCSV}
							>
								<span className="inline-block-visible-xl">Export CSV</span>
							</Button>
							<Button.Group size="large">
								<Button
									onClick={() => this.switchDisplayMode('list')}
									disabled={this.isDisplayModeActive('list')}
								>
									<i className="icons8-font icons8-bulleted-list-2" />
								</Button>
								<Button
									onClick={() => this.switchDisplayMode('map')}
									disabled={this.isDisplayModeActive('map')}
								>
									<i className="icons8-font icons8-location-marker" />
								</Button>
							</Button.Group>
							{currentUser.roles.some((role) => BUYER_ONLY_NO_STORE_ASSOCIATE.has(role)) ? (
								<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_LOCATIONS}>
									<OWButtonWithSupplierManagedLock
										size="large"
										type="primary"
										onClick={() => this.props.history.push('/buyer/locations/overview/new')}
									>
										Add Location
									</OWButtonWithSupplierManagedLock>
								</AccessPermissionChecker>
							) : null}
						</div>
					}
					mode={this.state.displayMode}
					handleQueryParams
					longitudeAccessor={(el) => nullSafeGet('buyerFacility.longitude', el)}
					latitudeAccessor={(el) => nullSafeGet('buyerFacility.latitude', el)}
					emptyState={
						<EmptyState
							graphic={
								<img
									alt="Looks like your team has not added any locations yet."
									style={{ marginBottom: 8 }}
									src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
								/>
							}
							headline={"It's a little lonely in here."}
							body={
								currentUser.roles.some((role) => BUYER_ONLY_NO_STORE_ASSOCIATE.has(role)) ? (
									<div style={{ textAlign: 'center' }}>
										<div style={{ maxWidth: 440, marginBottom: 16 }}>
											Looks like your team has not added any locations yet.
										</div>
										<OWButtonWithSupplierManagedLock
											type="primary"
											onClick={() => this.props.history.push('/buyer/locations/overview/new')}
										>
											Add your first location
										</OWButtonWithSupplierManagedLock>
									</div>
								) : (
									<div style={{ textAlign: 'center' }}>
										<div style={{ maxWidth: 440, marginBottom: 16 }}>
											Looks like your team has not setup access for you yet.
										</div>
										<Button type="primary" onClick={this.showRoleUpdateModal(currentUser)}>
											Request access to my location
										</Button>
									</div>
								)
							}
						/>
					}
					entityCollectionName="locations"
					targetCollectionName={TC_NAME}
					tableColumns={columns}
					popupRenderFunc={popupRenderFunc}
					showHeader={false}
					keyAccessor={(el) => el.id}
					onTableRow={onRow}
					preAppliedFilters={{ ...INITIAL_IS_ACTIVE_FILTERS }}
					fetchData={locationsRestCrudThunksForBuyer}
					stateSlice={locations}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,

	locations: state.locations,
	regions: state.regions,
	brands: state.brands,
	currentUser: state.session.currentUser,
	locationTypesAdditionalFields: state.location_types_additional_fields,
	locationTypes: state.location_types,
});

const mapDispatchToProps = (dispatch) => ({
	updateLocationsFilters: (filters, targetCollection) =>
		dispatch(LOCATIONS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)),
	clearAndUpdateFilters: (filters, targetCollectionName) =>
		dispatch(LOCATIONS_CRUD_ACTION_CREATORS.clearAndUpdateFilters(filters, targetCollectionName)),
	fetchRegionsWithChildren: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			fetchRegionsWithChildrenForBuyer(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleRegions: (ids, targetCollectionName) =>
		dispatch(regionsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	roleUpdateUser: (entity) => dispatch(buyerRoleUpdateUser(entity)),
	fetchMultipleLocationTypesAdditionalFields: (ids, targetCollectionName) =>
		dispatch(
			locationTypesAdditionalFieldsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)
		),
	fetchLocationTypesAdditionalFields: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			locationTypesAdditionalFieldsRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchBrands: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			brandsRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleBrands: (ids, targetCollectionName) =>
		dispatch(brandsRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchLocationTypes: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			locationTypesRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleLocationTypes: (ids, targetCollectionName) =>
		dispatch(locationTypesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	exportLocations: (params, filters) => dispatch(downloadLocationsCSVForBuyer(params, filters)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LocationsIndexPage));
